import { PropertyAggregation } from '../../../services/dtos/property';
import { buildSerpURLObject } from '../links';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function propertiesAreaToLinksList(areas: PropertyAggregation[] = [], locality: string) {
  return areas.map((item) => ({
    title: item.value,
    count: item.count,
    to: buildSerpURLObject({ locality, area: item.value }),
  }));
}
